import { ActivityTypeVisibility } from 'shared/contacts';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';

// The portal ActivityTab's per-type feature gating, mapped onto the shared
// Activity tab's visibility prop (same formulas the old tab computed inline).
export default function useActivityTypeVisibility(): ActivityTypeVisibility {
  const transactionsFeatureFlags = useModuleFeatureFlag('transactions');
  const statementsFeatureFlags = useModuleFeatureFlag('statements');
  const elinxFeatureFlags = useModuleFeatureFlag('eLinx');
  const clientAccountsFeatureFlags = useModuleFeatureFlag('clientAccounts');

  return {
    transactionHistory: Boolean(statementsFeatureFlags.ViewTransactionHistory),
    eLinxHistory: Boolean(elinxFeatureFlags.ViewPaylinkHitory),
    bankVerifyHistory: Boolean(statementsFeatureFlags.ViewBankVerify),
    scheduledTransactions: Boolean(transactionsFeatureFlags.ViewScheduledTransactions),
    scheduledClientAccountTransfers: Boolean(
      clientAccountsFeatureFlags.isEnabled && clientAccountsFeatureFlags.ViewClientAccounts,
    ),
  };
}
